const TICKET_BUDDY_AI_ACT_BASE_URL = 'https://ticket-buddy.com'

export const OFFICIAL_AI_ACT_URL = 'https://digital-strategy.ec.europa.eu/en/policies/regulatory-framework-ai'

const LOCALIZED_AI_ACT_LANGUAGES = new Set(['en', 'fr', 'es', 'it', 'pt', 'cs'])

/**
 * Returns the public Ticket Buddy AI Act guide for a supported admin locale.
 * German is the unprefixed canonical route; unknown locales fail back to it.
 */
export function ticketBuddyAiActUrl(locale: unknown): string {
  const language = String(locale || '').trim().toLowerCase().split(/[-_]/)[0]
  const prefix = LOCALIZED_AI_ACT_LANGUAGES.has(language) ? `/${language}` : ''
  return `${TICKET_BUDDY_AI_ACT_BASE_URL}${prefix}/eu-ai-act`
}
